import * as React from "react";
import './FormWelcome.css'
import FormButton from "../../../../../components/FormButton/FormButton";
import PlacesAutoCompleteContainer from "../../../../Bots/Common/PlacesAutoComplete/PlacesAutoCompleteContainer";
import {IGooglePlace} from "shared/model/ICoworkGeoLocation";
import {observer} from "mobx-react";
import {FormComponent} from "../../../state/FormsState";
import {toJS} from "mobx";
import {RouteComponentProps} from "react-router";
import NavigationConstants from "../../../../Navigation/NavigationConstants";
import MixPanelAnalyticsService from "../../../../../services/Analytics/MixPanelAnalyticsService";
import {AnalyticsSignUpEvents} from "../../../../../services/Analytics/AnalyticsSignUpEvents";
import GoogleAnalyticsService from "../../../../../services/Analytics/GoogleAnalyticsService";
import FormUtils from "../../../FormUtils";

interface IProps extends RouteComponentProps<any> {
    store: any
}

const storePropertyName = 'welcome';

@observer
export default class FormWelcome  extends React.Component<IProps> {
    public isSelectedFromList: boolean = false;

    constructor (props: IProps) {
        super(props);
        const {store} = this.props;
        store.navigationController[storePropertyName] = false;
        if (store.formInput[storePropertyName]) {
            this.selectPlace(store.formInput[storePropertyName].cowork);
            store.navigationController[storePropertyName] = true;
        }else{
            store.formInput[storePropertyName] = {}
        }
    }

    public selectPlace = (place: IGooglePlace | string) => {
        const {store} = this.props;
        store.formInput[storePropertyName].cowork = place;
        this.isSelectedFromList = true;
    };

    public next = () => {
        const {store} = this.props;
        if(!store.navigationController[storePropertyName]) {
            store.setWorkspaceError(true);
            return;
        }
        MixPanelAnalyticsService.track(AnalyticsSignUpEvents.GetStarted, {coworkSelected: store.formInput[storePropertyName].cowork});
        GoogleAnalyticsService.virtualPageView("/selectCowork");
        store.updateCurrentComponent(FormComponent.planSelect);
    };

    public updateSelectedCowork = (val: string) => {
        const {store} = this.props;
        store.formInput.welcome.cowork = val;
    };

    public navigateToLogin = () => {
        const {history} = this.props;
        MixPanelAnalyticsService.track(AnalyticsSignUpEvents.SwitchToLogin);
        history.replace(NavigationConstants.login);
    };

    public renderHeaders = () => {
        return (<>
            <div className="header">Grow your business.</div>
            <div className="sub-header">Check out our new financing plans.</div>
        </>);
    };

    public renderButton = () => {
        const {store} = this.props;
        return (
            <div className="btn-container">
                <FormButton classes={"yellow"} click={this.next} btnText={'Get started'}/>
                {store.workspaceError ? <div className="error">Enter a workspace to get started</div>: <div className="error-placeholder"/>}
            </div>
        )
    };

    public renderWorkspaceSelection = () => {
        const {store} = this.props;
        const initialValue = toJS(store.coWorkName);
        return (
            <div className="workspace-selection">
                <PlacesAutoCompleteContainer placeholder={"e.g Wework 430 Park Avenue, The Yard, Deskpass.."}
                                             inputLabel={"Browse workspaces"}
                                             navigationProperty={storePropertyName}
                                             initialValue={initialValue}
                                             updateStore={this.updateSelectedCowork} onPlaceSelected={this.selectPlace}
                                             autoFocus={true}/>
                {this.renderButton()}
                <div className="login">Salaryo member? <a href={FormUtils.getLoginLink()}>Log in</a></div>
            </div>
        )
    };

    public render() {
        return (
            <div className="welcome-container">
                {this.renderHeaders()}
                {this.renderWorkspaceSelection()}
            </div>
        );
    };
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/SignUpForm/FormWelcome/FormWelcome.tsx